// import components
import { styled, Box, Button, BoxProps, ButtonProps } from '@mui/material';

export const StyledNoteContainerBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  maxWidth: '640px',
  margin: 'auto',
  width: '100%'
}));

export const StyledButtonIcon = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isCompact'
})<ButtonProps & { isCompact?: boolean }>(({ theme, isCompact = false }) => ({
  display: 'flex',
  width: 'max-content',
  gap: theme.spacing(2),
  borderRadius: '32px',
  padding: isCompact ? theme.spacing(0, 2) : theme.spacing(2, 4)
}));
